/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
    });
  }

  getByAccountAndInbox(accountId, inboxId) {
    return axios.get(`/api/v1/accounts/${accountId}/inbox_members/${inboxId}`);
  }
}

export default new InboxMembers();
